<template>
  <div>
    <!-- Loading Spinner -->
    <loading-spinner v-if="isLoading" />
    <!-- Company Logo -->
    <company-logo />

    <!-- Header & Instruction -->
    <list-header title="Forgot your password?" />
    <div class="p-3 text-start">Please enter your mobile for verification.</div>

    <!-- Forgot Password Form -->
    <Form @submit="handleForgotPassword" :validation-schema="schema">
      <div class="mx-3">
        <div class="my-2">
          <Field name="phone" v-slot="{ handleChange, errorMessage }">
            <phone-input-field
              v-model:phoneNumber="enteredPhoneNumber"
              @update:phoneNumber="handleChange"
              :error-validate="errorMessage"
              @country-code="updateCountryCode"
            />
          </Field>
        </div>
      </div>

      <div class="scss-button-position-bottom">
        <div>
          <default-button title="Next" />
        </div>

        <div class="mb-2">
          <span
            class="scss-click-effect scss-text-blue scss-clickable"
            @click="goToSignInPage"
            >Back to login</span
          >
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form, Field } from "vee-validate";
import * as yup from "yup";

import ListHeader from "@/components/ListHeader.vue";
import PhoneInputField from "@/components/phoneInput/PhoneInputField.vue";
import DefaultButton from "@/components/button/DefaultButton.vue";
// import { forgotPassword } from "@/services/auth";
import CompanyLogo from "@/components/CompanyLogo.vue";
import LoadingSpinner from "@/components/LoadingSpinner";
import { validationRules } from "@/validation/ValidationRules";
import { checkDuplicateCustomerPhone, checkDuplicate } from "@/services/auth";
import { useToast } from "vue-toastification";

export default {
  name: "ForgotPassword",
  components: {
    ListHeader,
    DefaultButton,
    Form,
    Field,
    CompanyLogo,
    PhoneInputField,
    LoadingSpinner,
  },
  data() {
    return {
      email: "",
      enteredPhoneNumber: null,
      countryCode: "65",
      isLoading: false,
    };
  },
  methods: {
    goToSignInPage() {
      this.$router.push("/login");
    },
    async handleForgotPassword() {
      this.isLoading = true;
      const phoneWithCountryCode = `+${this.countryCode.toString()}${
        this.enteredPhoneNumber
      }`;
      try {
        const res = await checkDuplicate(phoneWithCountryCode);
        this.isLoading = false;

        if (res.status === 200) {
          return useToast().error(
            "Profile not registered. Please sign up for a new account to proceed. Thank you."
          );
        }
      } catch (error) {
        checkDuplicateCustomerPhone(phoneWithCountryCode)
          .then((response) => {
            this.isLoading = false;
            this.$store.commit("updateForgotPasswordTemporary", {
              phoneMobile: `+${this.countryCode.toString()}${
                this.enteredPhoneNumber
              }`,
              email: response?.data?.customerDetail?.email,
            });
            if (response?.data?.customerDetail?.email === "") {
              useToast().error(
                "Email for this phone number does not exist. Please contact the store to update your email.",
                { timeout: 5000 }
              );
            } else {
              this.$router.push("/forgot-password/reset");
            }
          })
          .catch(() => {
            this.isLoading = false;
            useToast().error("Phone number does not exist.");
          });
      }
    },
    updateCountryCode(value) {
      this.countryCode = value;
    },
  },
  computed: {
    schema() {
      return yup.object({
        phone: validationRules.phone,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.style-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.style-header {
  color: $text-green;
  font-size: 18px;
}

.style-icon {
  width: 40%;
  height: 40%;
}
</style>
